module.exports = __webpack_public_path__ + "static/media/cumberland.0322d84d.png";